/**
 * Filter model for the ⌘K palette (TAS-3542). Filters are DERIVED, not stored:
 * `type` + `lifecycle` are parsed out of the query STRING as token spans (see
 * `scopeQuery.parseQuerySpans`), so the raw text stays the single source of truth.
 * `status` is the scoped-view status sub-facet — a click selection that never lives
 * in the text — carried alongside the derived breadth filters when composing legs.
 *
 *   type       ─ which sections' legs are issued (union across type tokens)
 *   lifecycle  ─ is:open / is:closed — a status-set clause AND'd into each leg
 *   status     ─ the scoped-view status sub-facet (single-select, scope-bound)
 */
export type Filter =
  | { dim: 'type'; section: string }
  | { dim: 'lifecycle'; open: boolean }
  | { dim: 'status'; value: string };

/** Stable identity for dedupe + React keys + aria targeting. */
export const filterId = (f: Filter): string =>
  f.dim === 'type'
    ? `type:${f.section}`
    : f.dim === 'lifecycle'
      ? `lifecycle:${f.open ? 'open' : 'closed'}`
      : `status:${f.value}`;

/** True when a filter with this id is present (facet chips read their selected state through this). */
export const hasFilter = (filters: readonly Filter[], id: string): boolean => filters.some((f) => filterId(f) === id);
